import Resource from 'Resources/Resource';
import Project, { RawProject } from './Model/Project';
import parseProject from './parsers/project';
import Attributes from 'App/babel/attributes/Project';
import type ProjectSelection from './Model/ProjectSelection';

export type { Project };

class ProjectResource extends Resource {
	eventName = 'campaign';
	parse: (client: RawProject) => Project;
	constructor() {
		super('projects', Attributes);

		this.parse = parseProject;

		this.notifications = {
			save: () => ({
				title: 'default.saved',
				body: 'saved.campaign',
				style: 'success',
				icon: 'check',
				type: 'body'
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.campaign',
				style: 'error',
				icon: 'times',
				type: 'body'
			}),
			delete: () => ({
				title: 'default.deleted',
				body: 'deleted.campaign',
				style: 'success',
				icon: 'check',
				type: 'body'
			}),
			deleteError: () => ({
				title: 'default.error',
				body: 'deleteError.campaign',
				style: 'error',
				icon: 'times',
				type: 'body'
			})
		};
	}

	getSelections(projectId: number): Promise<ProjectSelection[]> {
		return this._getRequest(`${projectId}/selections`, { methodName: 'getSelections' }).then(
			({ data }: { data: { data: ProjectSelection[] } }) => data.data
		);
	}
}

export default new ProjectResource();
